import type { Ref } from 'vue';
import { ref } from 'vue';
import { deepCompareComputed } from '@/libraries/composables/deepCompareComputed';
import { eventResultScoreBetTypeGroupIds } from '@/libraries/oddsApi/betBuilderScoreSource';
import { EnumOddsCategoryType, useSimpleEventSubscription } from '@/types';

export function useSimpleEventSubscriptionCallback({
    eventId,
    isMixParlay,
    isActive = ref(true),
}: {
    eventId: Ref<number>;
    isMixParlay: Ref<boolean>;
    isActive?: Ref<boolean>;
}) {
    const variables = deepCompareComputed(() => ({
        query: {
            id: eventId.value,
            oddsCategory: isMixParlay.value ? EnumOddsCategoryType.MixParlay : EnumOddsCategoryType.All,
        },
        betTypeGroupIds: eventResultScoreBetTypeGroupIds,
    }));

    const { onSubscription } = useSimpleEventSubscription(
        variables,
        deepCompareComputed(() => ({
            enabled: isActive.value,
        })),
    );

    return {
        onSubscription,
    };
}
